import React from 'react';

import { FormattedMessage } from 'react-intl';

import { useOrgProfile } from '@modules/permissionManager/duck/hooks';
import {
  Card,
  DetailItem,
  ProgramLogo,
  S,
  UnitGenderPill,
} from '@modules/shared/components';

import styles from './UnitInfo.less';

export const UnitInfo = () => {
  const { data, isFetching: loading } = useOrgProfile();

  const {
    organizationFullName,
    councilName,
    districtName,
    charter,
    acceptGender,
    typeId,
    executiveOfficer,
  } = data || {};
  const { communityOrganizationName = '' } = charter || {};

  return (
    <Card margin shadow>
      <S size="4" hr bold colored>
        <FormattedMessage id="advancement.UnitInfo.heading" />
      </S>
      <Card noPadding loading={loading} className={styles.detailCard}>
        <div className={styles.detailsContainer}>
          <div>
            <div className={styles.titleContainer}>
              <div className={styles.titleRow}>
                <ProgramLogo className={styles.logo} programId={typeId} />
                <S size="4" bold className={styles.packName}>
                  {organizationFullName}
                </S>
                <UnitGenderPill gender={acceptGender} />
              </div>
            </div>

            <DetailItem
              className={styles.detailItem}
              label={<FormattedMessage id="advancement.UnitInfo.council" />}
            >
              {councilName}
            </DetailItem>
            <DetailItem
              className={styles.detailItem}
              label={<FormattedMessage id="advancement.UnitInfo.district" />}
            >
              {districtName}
            </DetailItem>
            <DetailItem
              className={styles.detailItem}
              label={
                <FormattedMessage id="advancement.UnitInfo.charteredOrg" />
              }
            >
              {communityOrganizationName}
            </DetailItem>
          </div>
          {executiveOfficer && (
            <Card className={styles.execOfficerCard}>
              <S size="4" bold colored>
                Executive officer
              </S>
              <div>{executiveOfficer.personFullName}</div>
            </Card>
          )}
        </div>
      </Card>
    </Card>
  );
};
